<app-header (notifyMobileOpen)="getMobileOpenNotification($event)"></app-header>
<div class="mainContainer">

    <app-menu selectedItem="posteingang" class="menu" [class.open]="mobileMenuOpen"></app-menu>

    <div class="content" [class.closed]="mobileMenuOpen">

        @if (!task) {
            <div>
                <h1>Posteingang</h1>

                @if (visibleNachrichten()) {
                    <div>
                        <pagination [numItems]="visibleNachrichten().length"
                                    [current]="currentOffset"
                                    (goToPageEvent)="pagerAction($event)"></pagination>

                        <elem-table #posteingangTable
                                    [tableData]="visibleNachrichten()"
                                    [tableMeta]="nachrichtMetaData"
                                    [targetParam]="'id'"
                                    [targetPath]="'kreditportal/posteingang/nachricht'"
                                    [searchAction]="searchMe"
                                    [currentOffset]="currentOffset"
                                    [lineHasChild]="false"
                                    [tableHover]="true"
                                    (goToPageEvent)="pagerAction($event)"></elem-table>

                        <pagination [numItems]="visibleNachrichten().length"
                                    [current]="currentOffset"
                                    (goToPageEvent)="pagerAction($event)"></pagination>
                    </div>
                }

            </div>
        }

    </div>
</div>
